import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Field = ({
    label,
    component: Component,
    name,
    children,
    className,
    helperMessage,
    ...rest
}) => {
    return (
        <div className={`mb-4 row justify-content-center ${className}`}>
            <label style={{fontSize: 14}} htmlFor={name} className="col-12 col-sm-3 text-start text-sm-end mb-2 mb-sm-0">
                {label} :
            </label>
            <div className="col-12 col-sm-7">
                {Component ? (
                    <Component
                        name={name}
                        {...rest}
                    />
                ) : (
                    children
                )}
                {helperMessage && <p className="small text-muted mt-2">
                    <FontAwesomeIcon icon={faCircleQuestion} className="me-2" />
                    {helperMessage}
                </p>}
            </div>
        </div>
    );
};

export default Field;
